import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Cookies from "universal-cookie";
import { inject, observer } from "mobx-react";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";

import "./Role.scss";
import { FETCH_URL } from "../../constants/ServerLinks";

@observer
class Role extends Component {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.cookies = new Cookies();
    this.world_skey = this.cookies.get("world_skey");
    this.config_number = this.cookies.get("config_number");
    this.country_name = this.cookies.get("country_name");
    this.country_id = this.cookies.get("country_id");
    this.role_id = this.cookies.get("role_id");
    this.roleAlias = this.cookies.get("role_alias");
    this.state = {
      roles: [],
      selected: props.isDelegate ? "ATGD" : this.roleAlias,
      participants: [],
    };

    // Fetch the roles from the backend
    this.fetchRolesAndPhotos();
  }

  fetchRolesAndPhotos = () => {
    axios
      .all([
        axios.get(this.fetchURL + "/api/v1/wiki/role/", {
          params: {
            config_number: this.config_number,
            country_name: this.country_name,
          },
        }),
        axios.get(this.fetchURL + "/api/v1/roles/photos/", {
          params: {
            country_id: this.country_id,
          },
        }),
      ])
      .then(
        axios.spread((wikiResponse, photoResponse) => {
          // console.group("Role:fetchRolesAndPhotos");
          // console.log(photoResponse.data.data);
          if (photoResponse.data.success) {
            let participantInfo = photoResponse.data.data;
            this.setState({ participants: participantInfo });
          }

          // console.log(wikiResponse.data.data);
          if (wikiResponse.data.success) {
            let rolesInfo = wikiResponse.data.data;
            this.setState({ roles: rolesInfo });
          }
          // console.groupEnd();
        })
      )
      .catch((error) => {
        console.log(error.response);
      });
  };

  roleSelected = (e, alias) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.setState((prevState) => ({
      selected: alias === prevState.selected ? "" : alias,
    }));
  };

  render() {
    const { countries } = this.props;

    return (
      <div
        className={`dash__wrap ${
          this.props.display === "show" ? "active" : "hidden"
        }`}
      >
        <div className="dash__outer">
          {!this.props.isDelegate && (
            <div>
              {/* <div className="header__roleWiki flex flex-wrap">
                            {Object.keys(this.state.participants).filter(p => !p.includes('ATG')).map((item, index) => {
                                const value = this.state.participants[item];
                                const role = countries.roles_data.find(r => r.alias === value[2] && r.country_name === this.country_name);
                                const imgSrc = {
                                    backgroundImage: `url(${value[1]})`
                                };
                                return (
                                    <div onClick={(e) => this.roleSelected(e, value[2])}
                                         className={`header__roleWrap ${this.state.selected === value[2] ? "active" : ""}`}
                                         key={index}>
                                        <div className="header__roleInner">
                                            <h6>{value[0] === 'N/A' ? '' : value[0]}</h6>
                                            <div className="header__imageAvatar container" style={imgSrc}/>
                                            <h4>{item}</h4>
                                            <div className="container efficiencyScore">
                                                {role && <Progress percent={role.efficiency_score}
                                                                   status={"default"}
                                                                   theme={{
                                                                       default: {
                                                                           color: '#232d4b'
                                                                       }
                                                                   }}/>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div> */}
              <div className="header__roleWikiPadding" />
            </div>
          )}

          {this.state.roles.map((item) => {
            const value = Object.values(item)[0];

            return (
              <div
                className={`dash__inner dash__roleWiki ${
                  this.state.selected === value.alias ? "active" : "hidden"
                }`}
                key={`rolWiki-${value.alias}`}
              >
                <div className="dash__panel">
                  <div className="dash__panelWrap white oh shadow w10 pb4 pr4 pl4 pt2">
                    <h2>{value.role_name}</h2>
                    <hr />
                    <div className="flex flex-wrap pt2 align-start">
                      <div className="flex-1">
                        {value.description.map((text, index) => (
                          <p key={`rolDes-${index}`}>{text}</p>
                        ))}
                      </div>
                      <div className="flex-auto roleWiki__blueBox t-white">
                        <h4>Policy Portfolio</h4>
                        <ul className="sq-bullets">
                          {value.policies.map((pol, index) => {
                            const name = Object.keys(pol)[0];
                            const desc = Object.values(pol)[0];
                            return (
                              <li className="pb2" key={`rolPol-${index}`}>
                                <strong>{name}:</strong> {desc}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dash__panel pt2 fg3">
                  <div className="dash__panelWrapOuter">
                    <div className="dash__panelWrap pb2 pt2 pl4 pr4 h10 shadow">
                      <h3 className="mb2">Political Climate</h3>
                      <p>{value.politics}</p>
                    </div>
                  </div>
                  <div className="dash__panelWrapOuter">
                    <div className="dash__panelWrap pb2 pt2 pl4 pr4 h10 shadow">
                      <h3 className="mb2">Economics</h3>
                      <p>{value.economics}</p>
                    </div>
                  </div>
                  <div className="dash__panelWrapOuter">
                    <div className="dash__panelWrap pb2 pt2 pl4 pr4 h10 shadow">
                      <h3 className="mb2">Human Rights</h3>
                      <p>{value.human_rights}</p>
                    </div>
                  </div>
                </div>

                <div className="dash__panel pt2">
                  <div className="dash__panelWrap pb2 pt2 pl4 pr4 h10 shadow">
                    <h3 className="mb2">Role Objectives</h3>
                    <p className="newline-fix">{value.exclusive}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <br />
        <br />
      </div>
    );
  }
}

Role.propTypes = {
  display: PropTypes.string.isRequired,
  isDelegate: PropTypes.bool.isRequired,
};

export default inject("countries")(Role);
